'use strict';
	
var EventsObject = function() {

    var eventStorage;

    function init(){
        eventStorage = {};
    }

    function dispose(){

    }

    function subscribe(namespace, callback){
        //eventStorage[namespace] = PubSub.subscribe(namespace, callback);
        PubSub.subscribe(namespace, callback);
    }

    function unsubscribe(namespace, callback){
        //PubSub.unsubscribe(eventStorage[namespace]);
        PubSub.unsubscribe([namespace, callback]);
    }

    function publish(namespace, args){
        PubSub.publish(namespace, args);
    }

    //////// PUBLIC INTERFACE /////////

    this.namespace = 'EVENTS';
    this.subscribe = subscribe;
    this.unsubscribe = unsubscribe;
    this.publish = publish;
    this.dispose = dispose;

    init();	
};

var Events = new EventsObject();
